module.exports = __webpack_public_path__ + "assets/img/dfzq.d0796add.png";